import React from 'react';
import { Button, Modal, Icon, Row, Table, Spin, Col, Tooltip } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import { Link } from 'dva/router';
import Sticky from 'react-sticky-el';
import { AjaxTable, BranchesReplace, SearchComponent } from '../../../components';
import MultiplyItemsColumnRender from '../../common/Table/MultiplyItemsColumnRender';
import styles from './../styles.less';
import { PencilIcon, TrashIcon } from '../../Icons';

class BranchesList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      removeBranchId: null,
      showDeleteReplaceConfirm: false,
      filter: {
        search: '**',
      },
    };
  }

  componentDidMount() {
    this.props.dispatch({
      type: 'header/update',
      payload: {
        title: 'Component.Branches.List.Title',
        description: 'Component.Branches.List.Description1',
      },
    });
    this.showNotifications();
  }

  getData(psf) {
    const filter = { name: this.state.filter.search, client_id: this.props.app.selectedClient.id };
    const params = psf.page ? psf : { sorting: psf.sorting, page: '1' };
    const payload = { filter, ...params };

    if (filter.name !== '**') {
      payload.filtered = true;
    }
    return this.props.dispatch({ type: 'branches/loadList', payload });
  }

  hideDeleteReplaceConfirm() {
    this.setState({
      showDeleteReplaceConfirm: false,
      removeBranchId: null,
    });
  }

  handleReplaceBranch(e, replaceBranchForm) {
    e.preventDefault();
    replaceBranchForm.validateFieldsAndScroll((err, payload) => {
      if (!err) {
        this.props.dispatch({
          type: 'branches/replace',
          payload: { ...payload, id: this.state.removeBranchId },
        }).then(() => {
          this.showNotifications();
          this.setState({
            removeBranchId: null,
            showDeleteReplaceConfirm: false,
          });
        });
      }
    });
  }

  showNotifications() {
    this.props.dispatch({ type: 'app/showNotifications' });
  }

  showDeleteConfirm = (record) => {
    const self = this;
    Modal.confirm({
      title: this.props.intl.formatMessage({ id: 'Common.Attention' }),
      content: this.props.intl.formatMessage({ id: 'Component.Branches.Modal.Description' }, { branchName: record.name }),
      okText: this.props.intl.formatMessage({ id: 'Common.Remove' }),
      cancelText: this.props.intl.formatMessage({ id: 'Common.Cancel' }),
      okType: 'danger',
      onOk() {
        self.remove(record.id);
      },
    });
  }

  remove(id) {
    this.hideDeleteReplaceConfirm();
    this.props.dispatch({ type: 'branches/remove', payload: { id } }).then((response) => {
      this.showNotifications();
      this.setState(
        { showDeleteReplaceConfirm: response.deleteConflict, removeBranchId: id });
    });
  }

  render() {
    const { Column } = Table;
    return (
      <div className={styles.containerLarge}>
        <Sticky
          className="sticky-bar"
          scrollElement=".ant-layout"
          stickyClassName="_sticky"
        >
          <div className="sticky-wrapper">
            <Row>
              <SearchComponent self={this} fieldPlaceholder={this.props.intl.formatMessage({ id: 'Component.Branches.List.SearchByName' })} />
              <Col span={14} className="text-right">
                <Button
                  size="large"
                  type="primary"
                  onClick={() => this.props.dispatch({
                    type: 'app/goToRoute',
                    payload: { routeName: 'BRANCH_NEW' },
                  })}
                >
                  <Icon type="plus" />
                  <FormattedMessage id="Component.Branches.List.Create" />
                </Button>
              </Col>
            </Row>
          </div>
        </Sticky>
        <Spin spinning={this.props.loading.models.branches}>
          <AjaxTable
            updateKey={JSON.stringify([this.state.filter, this.state.removeBranchId])}
            getData={this.getData.bind(this)}
            rowKey="id"
          >
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.Name' })}
              key="name"
              dataIndex="name"
              sorter
              className={styles.tableColumnWrap}
              render={data =>
                (<div
                  className={styles.row}
                  data-label={this.props.intl.formatMessage({ id: 'Grid.Column.Name' })}
                >
                  {data}
                </div>)}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.AssignmentToCompanyTracker' })}
              key="assignments"
              dataIndex="codes"
              className={styles.tableColumnWrap}
              render={codes => (
                <div
                  className={styles.row}
                  data-label={this.props.intl.formatMessage({ id: 'Grid.Column.AssignmentToCompanyTracker' })}
                >
                  {codes.length ?
                    <div className="cell-popover">
                      <MultiplyItemsColumnRender itemList={codes.map(i => i.label)} />
                    </div>
                    : <FormattedMessage id="Common.NoData" />
                  }
                </div>
              )}
            />
            <Column
              title={this.props.intl.formatMessage({
                id: 'Grid.Column.Actions',
              })}
              key="actions"
              className="text-center"
              width={150}
              fixed="right"
              render={item => (
                <div className="actions" data-label={item.id}>
                  <Tooltip
                    className="hint action-wrap"
                    placement="top"
                    title={this.props.intl.formatMessage({
                      id: 'Grid.Column.Edit',
                    })}
                  >
                    <Link to={`./${item.id}/edit/`}>
                      <PencilIcon />
                    </Link>
                  </Tooltip>
                  <Tooltip
                    className="hint action-wrap"
                    placement="top"
                    title={this.props.intl.formatMessage({
                      id: 'Grid.Column.Delete',
                    })}
                  >
                    <button onClick={() => this.showDeleteConfirm(item)}>
                      <TrashIcon />
                    </button>
                  </Tooltip>
                </div>
              )}
            />
          </AjaxTable>
        </Spin>
        <Modal
          wrapClassName="branchesReplaceModal"
          visible={this.state.showDeleteReplaceConfirm}
          onOk={() => this.remove(this.state.removeBranchId)}
          onCancel={this.hideDeleteReplaceConfirm.bind(this)}
          okText={this.props.intl.formatMessage({ id: 'Component.Branches.ReplaceModal.Ok' })}
          cancelText={this.props.intl.formatMessage({ id: 'Common.Cancel' })}
        >
          <BranchesReplace
            bid={this.state.removeBranchId}
            handleReplaceBranch={this.handleReplaceBranch.bind(this)}
          />
        </Modal>
      </div>
    );
  }
}

export default connect(
  ({ branches, loading, app }) => ({ branches, loading, app }),
)(injectIntl(BranchesList));



// WEBPACK FOOTER //
// ./src/components/Branches/BranchesList/BranchesList.js